export default __webpack_public_path__ + "b79ef88a665a1e752f1bd9dfe763c16a.mp3";